import { ClientError, isProjectRenameError } from "@opencode/client/promise"

type Translator = (
  key: "project.rename.unavailable" | "project.rename.failedStatus",
  params: { status: number },
) => string

export function projectRenameError(error: unknown, translate: Translator) {
  if (isProjectRenameError(error)) return new Error(error.message, { cause: error })
  if (!(error instanceof ClientError) || error.reason !== "UnexpectedStatus") return error
  const cause = error.cause
  if (!cause || typeof cause !== "object" || !("status" in cause) || typeof cause.status !== "number") return error
  return new Error(
    translate(
      cause.status === 404 || cause.status === 405 ? "project.rename.unavailable" : "project.rename.failedStatus",
      { status: cause.status },
    ),
    { cause: error },
  )
}
